"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6970],{

/***/ 86970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ mulai_investasi; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@stockbit/ui/index.js
var ui = __webpack_require__(76825);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/styled.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: calc(100% - 50px);\n  margin: auto;\n  @media ",
        " {\n    max-width: 1300px;\n    width: calc(100% - 150px);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 100px;\n  font-size: 44px;\n\n  .header-title {\n    font-size: 48px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n\n  @media ",
        " {\n    text-align: left;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  img {\n    width: 50px;\n    height: 50px;\n    object-fit: contain;\n    margin: 20px auto;\n\n    @media ",
        " {\n      margin: 20px 0;\n    }\n  }\n\n  h2 {\n    margin-bottom: 10px;\n    text-align: center;\n\n    @media ",
        " {\n      margin: 20px 0;\n      text-align: left;\n    }\n  }\n\n  @media ",
        " {\n    justify-content: flex-start;\n    align-items: flex-start;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Flex = ui/* Common.Flex */.Gn.Flex, Text = ui/* Common.Text */.Gn.Text;
var Container = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-27bec49d-0"
})(_templateObject(), ui/* device.tablet */.Uh.tablet);
var Title = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "h2",
    family: "bold",
    align: "center"
}).withConfig({
    componentId: "sc-27bec49d-1"
})(_templateObject1());
var Description = (0,styled_components_browser_esm["default"])(Text).attrs({
    as: "p",
    color: ui/* color.dimgray */.$_.dimgray
}).withConfig({
    componentId: "sc-27bec49d-2"
})(_templateObject2(), ui/* device.laptop */.Uh.laptop);
var Item = (0,styled_components_browser_esm["default"])(Flex).withConfig({
    componentId: "sc-27bec49d-3"
})(_templateObject3(), ui/* device.laptop */.Uh.laptop, ui/* device.laptop */.Uh.laptop, ui/* device.laptop */.Uh.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Benefits/styled.ts

function styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 75px 0;\n\n  img {\n    width: 50px;\n    height: 50px;\n    object-fit: contain;\n  }\n\n  @media ",
        " {\n    align-items: flex-start;\n    flex-direction: row;\n\n    .benefit__sized {\n      width: 25%;\n      margin-right: 75px;\n    }\n\n    .benefit__sized:last-child {\n      margin-right: 0;\n    }\n  }\n"
    ]);
    styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var styled_Flex = ui/* Common.Flex */.Gn.Flex;
// eslint-disable-next-line import/prefer-default-export
var BenefitsContainer = (0,styled_components_browser_esm["default"])(styled_Flex).withConfig({
    componentId: "sc-7b424692-0"
})(styled_templateObject(), ui/* device.laptop */.Uh.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Benefits/constants.ts
var benefits = [
    {
        image: "/images/mulai-investasi/benefit1.png",
        title: "Mudah Digunakan",
        desc: "Di design oleh investor khusus untuk investor. Mulai berinvestasi tanpa manual. <br /> Swipe. Order. Done."
    },
    {
        image: "/images/mulai-investasi/benefit2.png",
        title: "Keamanan Generasi Terbaru",
        desc: "Dilengkapi dengan teknologi keamanan yang canggih menggunakan Fingerprint dan Face ID untuk kemudahan dan keamanan Anda."
    },
    {
        image: "/images/mulai-investasi/benefit3.png",
        title: "Dana Anda Aman",
        desc: "Semua dana Anda akan disimpan di rekening terpisah di Rekening Dana Nasabah (RDN) atas nama Anda sendiri sehingga tidak dapat disalahgunakan oleh pihak lain."
    },
    {
        image: "/images/mulai-investasi/benefit4.png",
        title: "Personal Customer Support",
        desc: "Tim support kami selalu siap untuk membantu masalah Anda lewat live chat support kami."
    }, 
];
/* harmony default export */ var constants = (benefits);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Benefits/index.tsx






var Benefits_Text = ui/* Common.Text */.Gn.Text;
var MulaiInvestasiBenefits = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsContainer, {
        children: constants.map(function(b) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                className: "benefit__sized",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: b.image
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits_Text, {
                        size: "30px",
                        family: "bold",
                        as: "h2",
                        children: b.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        size: "17px",
                        dangerouslySetInnerHTML: {
                            __html: b.desc
                        }
                    })
                ]
            }, b.title);
        })
    });
};
/* harmony default export */ var Benefits = (MulaiInvestasiBenefits);

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(508);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/ComparisonGraph/styled.ts

function ComparisonGraph_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 100px 0;\n\n  h2 {\n    text-align: center;\n    margin-bottom: 20px;\n    @media ",
        " {\n      text-align: left;\n    }\n  }\n\n  &>.note {\n    margin-top: 20px;\n    @media ",
        " {\n      display: none;\n    }\n  }\n\n  .note {\n    p {\n      display: block;\n      padding-left: 15px;\n      position: relative;\n\n      &:before {\n        content: '*)';\n        position: absolute;\n        top: 0;\n        left: 0;\n      }\n    }\n  }\n"
    ]);
    ComparisonGraph_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: 0.6fr 1.4fr;\n    grid-template-rows: 1fr;\n    grid-column-gap: 50px;\n    grid-row-gap: 0px; \n  }\n"
    ]);
    styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n\n  .note {\n    display: none;\n    @media ",
        " {\n      display: block;\n    }\n  }\n\n  @media ",
        " {\n    justify-content: space-between;\n    padding: 58px 0;\n  }\n"
    ]);
    styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  flex-direction: column;\n\n  @media ",
        " {\n    flex-direction: row;\n  }\n\n  @media ",
        " {\n    flex-direction: column;\n  }\n\n  > div {\n    width: 100%;\n    margin-bottom: 20px;\n    div {\n      text-align: center;\n      align-items: center;\n      justify-content: center;\n\n      @media ",
        " {\n        justify-content: flex-start;\n        text-align: left;\n      }\n    }\n\n\n    @media ",
        " {\n      width: 50%;\n      margin: 10px 10px 50px 10px;\n    }\n\n    @media ",
        " {\n      width: 100%;\n      margin-bottom: 20px;\n    }\n  }\n"
    ]);
    styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: relative;\n  flex-direction: column-reverse;\n  @media ",
        " {\n    flex-direction: column;\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 0;\n  border-bottom: solid 1px ",
        ";\n  font-family: inherit;\n  font-weight: bold;\n  font-size: 30px;\n  color: ",
        ";\n  width: auto;\n  max-width: 90%;\n\n  &:focus {outline: none; border-bottom: solid 1px ",
        "}\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 100%;\n  margin: 25px 0;\n  width: 384px;\n\n  > div {\n    width: 50%;\n    margin-right: 25px;\n  }\n  .sfaqchart-l {\n    width: 15px;\n    height: 10px;\n    margin-top: 4px;\n    margin-right: 10px;\n\n    &.l-deposito {\n      background-color: #0099e5;\n    }\n\n    &.l-saham {\n      background-color: #34bf49;\n    }\n  }\n  @media ",
        " {\n    margin: 0 0 25px 105px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var ComparisonGraph_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var ComparisonContainer = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-3b3608df-0"
})(ComparisonGraph_styled_templateObject(), ui/* device.laptop */.Uh.laptop, ui/* device.laptop */.Uh.laptop);
var GraphContainer = styled_components_browser_esm["default"].section.withConfig({
    componentId: "sc-3b3608df-1"
})(styled_templateObject1(), ui/* device.laptop */.Uh.laptop);
var GraphSidebar = (0,styled_components_browser_esm["default"])(ComparisonGraph_styled_Flex).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-3b3608df-2"
})(styled_templateObject2(), ui/* device.laptop */.Uh.laptop, ui/* device.laptop */.Uh.laptop);
var GraphInputContainer = (0,styled_components_browser_esm["default"])(ComparisonGraph_styled_Flex).attrs({
    justify: "space-between",
    align: "flex-start"
}).withConfig({
    componentId: "sc-3b3608df-3"
})(styled_templateObject3(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop, ui/* device.laptop */.Uh.laptop, ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var GraphContent = (0,styled_components_browser_esm["default"])(ComparisonGraph_styled_Flex).withConfig({
    componentId: "sc-3b3608df-4"
})(_templateObject4(), ui/* device.laptop */.Uh.laptop);
var Input = styled_components_browser_esm["default"].input.withConfig({
    componentId: "sc-3b3608df-5"
})(_templateObject5(), ui/* color.gainsboro */.$_.gainsboro, ui/* color.nightRider */.$_.nightRider, ui/* color.primary */.$_.primary);
var GraphContentInfo = (0,styled_components_browser_esm["default"])(ComparisonGraph_styled_Flex).attrs({
    direction: "row",
    justify: "space-between",
    align: "flex-start"
}).withConfig({
    componentId: "sc-3b3608df-6"
})(_templateObject6(), ui/* device.laptop */.Uh.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/ComparisonGraph/index.tsx






var ComparisonGraph_Flex = ui/* Common.Flex */.Gn.Flex, ComparisonGraph_Text = ui/* Common.Text */.Gn.Text;
var options = {
    responsive: true,
    plugins: {
        legend: {
            display: false
        }
    },
    scales: {
        y: {
            ticks: {
                font: {
                    family: "ProximaNovaRg",
                    size: 15
                },
                callback: function callback(value) {
                    return numeral_default()(value).format("0.0 a").toUpperCase();
                }
            }
        },
        x: {
            ticks: {
                font: {
                    family: "ProximaNovaRg",
                    size: 15
                }
            }
        }
    }
};
var Note = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "note",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonGraph_Text, {
            color: ui/* color.dimgray */.$_.dimgray,
            size: "14px",
            children: [
                "Asumsi konservatif berdasarkan pertumbuhan IHSG sebesar 19.7% per tahun selama 15 tahun terakhir.",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                " Simulasi ini berdasarkan kinerja masa lalu dan tidak menjanjikan kinerja masa depan."
            ]
        })
    });
};
var ComparisonGraph = function() {
    var depositYearlyInterest = 0.00417;
    var stockYearlyInterest = 0.011715;
    var initialMonthlyDeposit = 1000000;
    var ref = (0,react.useState)(initialMonthlyDeposit), monthlyDeposit = ref[0], setMonthlyDeposit = ref[1];
    var ref1 = (0,react.useState)(numeral_default()(initialMonthlyDeposit).format("0,0")), monthlyDepositValue = ref1[0], setMonthlyDepositValue = ref1[1];
    var ref2 = (0,react.useState)(21), savingPeriod = ref2[0], setSavingPeriod = ref2[1];
    var ref3 = (0,react.useState)([]), depositValueOverTime = ref3[0], setDepositValueOverTime = ref3[1];
    var ref4 = (0,react.useState)([]), chartPeriods = ref4[0], setChartPeriods = ref4[1];
    var ref5 = (0,react.useState)([]), stocksValueOverTime = ref5[0], setStocksValueOverTime = ref5[1];
    var ref6 = (0,react.useState)({
        labels: chartPeriods,
        datasets: [
            {
                pointRadius: 0,
                borderColor: "#0099e5",
                backgroundColor: "rgba(255,255,255,0)",
                label: "deposito, kenaikan 5% p.a",
                data: depositValueOverTime
            },
            {
                pointRadius: 0,
                borderColor: "#34bf49",
                backgroundColor: "rgba(255,255,255,0)",
                label: "investasi saham, kenaikan 15% p.a",
                data: stocksValueOverTime
            }, 
        ]
    }), data = ref6[0], setData = ref6[1];
    var generateSchemePeriod = function() {
        var newChartPeriods = [];
        for(var year = 0; year <= savingPeriod; year += 1){
            newChartPeriods.push(year);
        }
        setChartPeriods(newChartPeriods);
    };
    var generateBankDepositScheme = function() {
        var newDepositValueOverTime = [];
        for(var year = 0; year <= savingPeriod; year += 1){
            var depositValueYearly = (monthlyDeposit + monthlyDeposit / depositYearlyInterest) * Math.pow(1 + depositYearlyInterest, year * 12) - monthlyDeposit / depositYearlyInterest;
            newDepositValueOverTime.push(Math.round(depositValueYearly));
        }
        setDepositValueOverTime(newDepositValueOverTime);
    };
    var generateStockScheme = function() {
        var newStocksValueOverTime = [];
        for(var year = 0; year <= savingPeriod; year += 1){
            var stockValueYearly = (monthlyDeposit + monthlyDeposit / stockYearlyInterest) * Math.pow(1 + stockYearlyInterest, year * 12) - monthlyDeposit / stockYearlyInterest;
            newStocksValueOverTime.push(Math.round(stockValueYearly));
        }
        setStocksValueOverTime(newStocksValueOverTime);
    };
    (0,react.useEffect)(generateSchemePeriod, [
        savingPeriod
    ]);
    (0,react.useEffect)(generateStockScheme, [
        savingPeriod,
        monthlyDeposit,
        stockYearlyInterest, 
    ]);
    (0,react.useEffect)(generateBankDepositScheme, [
        savingPeriod,
        monthlyDeposit,
        depositYearlyInterest, 
    ]);
    (0,react.useEffect)(function() {
        var newData = {
            labels: chartPeriods,
            datasets: [
                {
                    radius: 0,
                    borderColor: "#0099e5",
                    backgroundColor: "rgba(255,255,255,0)",
                    label: "deposito, kenaikan 5% p.a",
                    data: depositValueOverTime
                },
                {
                    radius: 0,
                    borderColor: "#34bf49",
                    backgroundColor: "rgba(255,255,255,0)",
                    label: "investasi saham, kenaikan 15% p.a",
                    data: stocksValueOverTime
                }, 
            ]
        };
        setData(newData);
    }, [
        depositValueOverTime,
        chartPeriods,
        stocksValueOverTime
    ]);
    var calculateWidth = function(value) {
        return "".concat(String(value || 2).length * 23, "px");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonGraph_Text, {
                size: "40px",
                family: "bold",
                as: "h2",
                children: "Grafik Perbandingan"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphSidebar, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphInputContainer, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonGraph_Text, {
                                                size: "19px",
                                                as: "div",
                                                children: "Investasi per Bulan"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonGraph_Flex, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonGraph_Text, {
                                                        size: "19px",
                                                        as: "div",
                                                        padding: "0 10px 0 0",
                                                        children: "Rp"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonGraph_Text, {
                                                        family: "bold",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                            value: monthlyDepositValue,
                                                            onChange: function(e) {
                                                                e.preventDefault();
                                                                var value = numeral_default()(e.target.value).value();
                                                                setMonthlyDeposit(value);
                                                                setMonthlyDepositValue(numeral_default()(value).format("0,0"));
                                                            },
                                                            style: {
                                                                width: calculateWidth(monthlyDepositValue)
                                                            }
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonGraph_Text, {
                                                size: "19px",
                                                as: "div",
                                                children: "Jangka Waktu Investasi"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonGraph_Flex, {
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonGraph_Text, {
                                                        family: "bold",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                                                            value: savingPeriod,
                                                            onChange: function(e) {
                                                                e.preventDefault();
                                                                var value = numeral_default()(e.target.value).value();
                                                                setSavingPeriod(value);
                                                            },
                                                            style: {
                                                                width: calculateWidth(savingPeriod)
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ComparisonGraph_Text, {
                                                        size: "19px",
                                                        as: "div",
                                                        padding: "0 0 0 10px",
                                                        children: "Tahun"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Note, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(GraphContentInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonGraph_Flex, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sfaqchart-l l-deposito"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonGraph_Text, {
                                                size: "15px",
                                                as: "div",
                                                children: [
                                                    "Kenaikan Deposito ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    "5% per tahun"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonGraph_Flex, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sfaqchart-l l-saham"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ComparisonGraph_Text, {
                                                size: "15px",
                                                as: "div",
                                                children: [
                                                    "Kenaikan IHSG",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " 15% per tahun *)"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
                                options: options,
                                data: data
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Note, {})
        ]
    });
};
/* harmony default export */ var mulai_investasi_ComparisonGraph = (ComparisonGraph);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/Features/constants.ts
var features = [
    {
        image: "/images/mulai-investasi/feature1.png",
        title: "Platform Charting Modern",
        desc: "Tingkatkan analisis teknikal Anda dengan fitur charting canggih. Dilengkapi live price data dan ratusan indikator yang siap dipakai untuk membantu Anda mengambil keputusan trading."
    },
    {
        image: "/images/mulai-investasi/feature2.png",
        title: "Screener Terbaik",
        desc: "Cari dan pilih saham sesuai dengan kriteria yang Anda inginkan. Buat sendiri aturan screening dengan ratusan kriteria yang tersedia atau gunakan langsung preset screener dengan kriteria para <i>guru</i> saham terkenal."
    },
    {
        image: "/images/mulai-investasi/feature3.png",
        title: "Data Finansial yang Lengkap",
        desc: "Disajikan dalam berbagai jenis periode dengan data historikal hingga lebih dari 10 tahun. Dilengkapi dengan rasio-rasio keuangan dan data yang akurat dan terpercaya langsung dari sumber resmi."
    },
    {
        image: "/images/mulai-investasi/feature4.png",
        title: "PE Standard Deviation Band",
        desc: "Tools canggih yang sering digunakan oleh institusi dan pemain besar untuk mengetahui apakah suatu saham masih murah atau sudah mahal secara cepat dan mudah."
    }, 
];
/* harmony default export */ var Features_constants = (features);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Features/styled.ts

function Features_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background: no-repeat center right / 16px auto;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAG2SURBVGhD7Zi/LwRREMcHodAo0BGNQohEoqBQEYma+AMUNm7eXaGQiMKV/AEKEqUf2XmH5HqNSqGi1BCdSkIkkuPM25uTW3ul4ibmk0wut+9bzCf73tt9C4ZhGIZhGMY/4jjqg2KxXf4ppApt4J3nqoLHRyCckBFlEM7UJOqFzxDjsIwqIi6MArmvlAy5BzgrDEhCEbHbTokkhbcs2S8JRRDuZWTIXUM56paEEmqL/igj4/ESqNglKSWEhsmVszK8q9Fyh6SUEKYS4VUTmf3krqmCop5ksWdldiTRhHPXC5SbbLmKcYEbf/klUuXrG9J5Ax7XuT4z4Vau8MwhtyIGTG2XyBrrqAo/e+bFhCF31ySkoe7TD8tSfoRlYh64adF65UpLED7BaW5QDBRQckvceCUtwi+UHsckoYA4P8sNf6Qlwt3BKUkoIDTr8S0twVJBTg2xG+emefo0SoTplVuUhAJKOJQs5EaJ5JyCq5JQQNhKw5baKJGI4KYkFBA+OIRzR1ZiVxJKOFubzkh4PNT3phvO5h7ffyQIL/SdPep4nOPpdcK/W3AQdcpVwzAMwzAMw/gLAL4BSNemrTyIDIIAAAAASUVORK5CYII=');\n  color: ",
        ";\n  font-size: 14px;\n  margin: auto;\n  padding-right: 30px;\n  @media ",
        " {\n    margin: 0;\n  }\n\n  b {\n    font-family: var(--bold-font);\n  }\n\n  &:hover {\n    color: ",
        ";\n  }\n"
    ]);
    Features_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Features_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 50px auto;\n\n  @media ",
        " {\n    display: grid;\n    grid-template-columns: 0.6fr 1.4fr;\n    grid-template-rows: 1fr;\n    grid-column-gap: 100px;\n    grid-row-gap: 100px;\n  }\n"
    ]);
    Features_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Features_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n\n  p {\n    margin: 10px 0;\n  }\n\n  h2 {\n    margin-top: 0;\n    font-size: 40px;\n    text-align: center;\n    display: block;\n    width: 100%;\n\n    @media ",
        " {\n      text-align: left;\n    }\n  }\n"
    ]);
    Features_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Features_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-columns: 1fr;\n  grid-template-rows: repeat(4, 1fr);\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(2, 1fr);\n    grid-column-gap: 80px;\n    grid-row-gap: 0px;\n\n    img {\n      margin: 25px 0;\n    }\n  }\n"
    ]);
    Features_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Features_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var ProceedLink = styled_components_browser_esm["default"].a.withConfig({
    componentId: "sc-3d384e4d-0"
})(Features_styled_templateObject(), ui/* color.primary */.$_.primary, ui/* device.laptop */.Uh.laptop, ui/* color.primary */.$_.primary);
var FeatureContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3d384e4d-1"
})(Features_styled_templateObject1(), ui/* device.laptop */.Uh.laptop);
var FeatureSidebar = (0,styled_components_browser_esm["default"])(Features_styled_Flex).withConfig({
    componentId: "sc-3d384e4d-2"
})(Features_styled_templateObject2(), ui/* device.laptop */.Uh.laptop);
var FeatureList = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-3d384e4d-3"
})(Features_styled_templateObject3(), ui/* device.tablet */.Uh.tablet);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Features/index.tsx







var Features_Text = ui/* Common.Text */.Gn.Text;
var MulaiInvestasiFeatures = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FeatureSidebar, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                        children: "Fitur Investasi Terlengkap"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                        size: "16px",
                        children: "Pertajam analisis Anda dalam berinvestasi dengan fitur-fitur professional. Tingkatkan potensi untuk mendapatkan keuntungan yang maksimal."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/info/pro-tools",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProceedLink, {
                            children: "Pelajari Lebih Lanjut"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureList, {
                children: Features_constants.map(function(b) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: b.image
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features_Text, {
                                size: "19px",
                                family: "bold",
                                as: "h2",
                                children: b.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                                size: "16px",
                                dangerouslySetInnerHTML: {
                                    __html: b.desc
                                }
                            })
                        ]
                    }, b.title);
                })
            })
        ]
    });
};
/* harmony default export */ var Features = (MulaiInvestasiFeatures);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Header/styled.ts

function Header_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex-direction: column;\n  justify-content: flex-end;\n  min-height: 100vh;\n\n  @media ",
        " {\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  img {\n    max-width: 100%;\n  }\n"
    ]);
    Header_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Header_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 120px;\n  font-size: 48px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 60px;\n    text-align: left;\n  }\n"
    ]);
    Header_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Header_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media ",
        " {\n    width: 60%;\n    padding-right: 50px;\n  }\n"
    ]);
    Header_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Header_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 18px;\n  margin: 30px 0;\n  padding-top: 15px;\n  text-align: center;\n\n  @media ",
        " {\n    font-size: 22px;\n    margin: 0 0 9vh 0;\n    text-align: left;\n  }\n"
    ]);
    Header_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var Header_styled_Flex = ui/* Common.Flex */.Gn.Flex, styled_Text = ui/* Common.Text */.Gn.Text;
var Header = (0,styled_components_browser_esm["default"])(Header_styled_Flex).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-6257bcf0-0"
})(Header_styled_templateObject(), ui/* device.laptop */.Uh.laptop);
var HeaderTitle = (0,styled_components_browser_esm["default"])(styled_Text).attrs({
    as: "h1",
    family: "bold"
}).withConfig({
    componentId: "sc-6257bcf0-1"
})(Header_styled_templateObject1(), ui/* device.laptop */.Uh.laptop);
var HeaderDescription = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-6257bcf0-2"
})(Header_styled_templateObject2(), ui/* device.laptop */.Uh.laptop);
var HeaderSubtitle = (0,styled_components_browser_esm["default"])(styled_Text).withConfig({
    componentId: "sc-6257bcf0-3"
})(Header_styled_templateObject3(), ui/* device.laptop */.Uh.laptop);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Header/index.tsx



var MulaiInvestasiHeader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Header, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderDescription, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderTitle, {
                        children: [
                            "Daftar 100% Online",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "Tanpa Minimum Deposit"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HeaderSubtitle, {
                        children: "Akun rekening kamu akan diproses secara digital tanpa perlu mengirim dokumen fisik."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                src: "/images/pro2-new.svg"
            })
        ]
    });
};
/* harmony default export */ var mulai_investasi_Header = (MulaiInvestasiHeader);

// EXTERNAL MODULE: ./src/constants/app.js
var app = __webpack_require__(86123);
;// CONCATENATED MODULE: ./src/features/mulai-investasi/Komisi/styled.ts

function Komisi_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding: 50px;\n  background: url(",
        "/images/mulai-investasi/table-price-left.svg) no-repeat top\n      left,\n    url(",
        "/images/mulai-investasi/table-price-right.svg) no-repeat bottom right;\n  background-size: 50px, 50px;\n\n  > div {\n    width: 50%;\n  }\n\n  @media ",
        " {\n    padding: 100px;\n    background-size: 100px, 100px;\n  }\n"
    ]);
    Komisi_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Komisi_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: auto;\n  width: 100%;\n  @media ",
        " {\n    width: 70%;\n  }\n"
    ]);
    Komisi_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Komisi_styled_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 36px;\n  @media ",
        " {\n    font-size: 50px;\n  }\n  @media ",
        " {\n    font-size: 80px;\n  }\n"
    ]);
    Komisi_styled_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Komisi_styled_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 20px;\n  @media ",
        " {\n    font-size: 24px;\n  }\n"
    ]);
    Komisi_styled_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}



var Komisi_styled_Flex = ui/* Common.Flex */.Gn.Flex, Komisi_styled_Text = ui/* Common.Text */.Gn.Text;
var KomisiList = (0,styled_components_browser_esm["default"])(Komisi_styled_Flex).withConfig({
    componentId: "sc-1ef8f81e-0"
})(Komisi_styled_templateObject(), app/* assetPrefix */.Vc, app/* assetPrefix */.Vc, ui/* device.tablet */.Uh.tablet);
var KomisiContainer = styled_components_browser_esm["default"].div.withConfig({
    componentId: "sc-1ef8f81e-1"
})(Komisi_styled_templateObject1(), ui/* device.laptopL */.Uh.laptopL);
var KomisiNumber = (0,styled_components_browser_esm["default"])(Komisi_styled_Text).attrs({
    align: "center",
    family: "bold",
    color: ui/* color.primary */.$_.primary
}).withConfig({
    componentId: "sc-1ef8f81e-2"
})(Komisi_styled_templateObject2(), ui/* device.tablet */.Uh.tablet, ui/* device.laptop */.Uh.laptop);
var KomisiTitle = (0,styled_components_browser_esm["default"])(Komisi_styled_Text).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-1ef8f81e-3"
})(Komisi_styled_templateObject3(), ui/* device.tablet */.Uh.tablet);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Komisi/index.tsx




var Komisi_Text = ui/* Common.Text */.Gn.Text;
var MulaiInvestasiKomisi = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(KomisiContainer, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "Biaya Komisi"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(KomisiList, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiTitle, {
                                children: "Fee Beli"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiNumber, {
                                children: "0,15%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiTitle, {
                                children: "Fee Jual"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KomisiNumber, {
                                children: "0,25%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Komisi_Text, {
                size: "20px",
                align: "center",
                padding: "15px 60px",
                as: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Komisi_Text, {
                        size: "20px",
                        family: "bold",
                        as: "b",
                        children: "Keterangan:"
                    }),
                    " ",
                    "Sudah termasuk biaya broker, biaya levy (BEI, KPEI, KSEI) 0,043%, PPN biaya",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "broker 10%, dan PPh final untuk transaksi jual 0,1%."
                ]
            })
        ]
    });
};
/* harmony default export */ var Komisi = (MulaiInvestasiKomisi);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Steps/styled.ts

function Steps_styled_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &:before {\n    height: 0px;\n    width: 80%;\n    border-bottom: 2px dashed ",
        ";\n    content: '';\n    position: absolute;\n    top: 46px;\n    left: 10%;\n    @media ",
        " {\n      border-bottom: 4px dashed ",
        ";\n      top: 76px;\n      left: 20%;\n      width: 60%;\n    }\n  }\n"
    ]);
    Steps_styled_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Steps_styled_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  position: relative;\n  width: calc(100% / 3);\n  margin: 25px 10px;\n  padding: 5px;\n  background: #fff;\n\n  @media ",
        " {\n    background: transparent;\n\n    p {\n      font-size: 19px;\n    }\n  }\n\n  img {\n    max-width: 100%;\n    width: 50px;\n    height: 50px;\n    object-fit: contain;\n    @media ",
        " {\n      width: 120px;\n      height: 120px;\n      margin-bottom: 20px;\n      background: ",
        ";\n    }\n  }\n"
    ]);
    Steps_styled_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}


var Steps_styled_Flex = ui/* Common.Flex */.Gn.Flex;
var InvestementContainer = (0,styled_components_browser_esm["default"])(Steps_styled_Flex).withConfig({
    componentId: "sc-4b45cdcf-0"
})(Steps_styled_templateObject(), ui/* color.midgray */.$_.midgray, ui/* device.tablet */.Uh.tablet, ui/* color.midgray */.$_.midgray);
var InvestStep = (0,styled_components_browser_esm["default"])(Steps_styled_Flex).attrs({
    justify: "flex-end",
    align: "center",
    direction: "column"
}).withConfig({
    componentId: "sc-4b45cdcf-1"
})(Steps_styled_templateObject1(), ui/* device.tablet */.Uh.tablet, ui/* device.tablet */.Uh.tablet, ui/* color.light */.$_.light);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/Steps/index.tsx





var Steps_Text = ui/* Common.Text */.Gn.Text;
var MulaiInvestasiSteps = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: "3 Langkah Mudah Investasi Saham di Stockbit"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestementContainer, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestStep, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/mulai-investasi/step1.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps_Text, {
                                size: "17px",
                                align: "center",
                                children: [
                                    "Pastikan Anda",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " memiliki akun Stockbit"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestStep, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/mulai-investasi/step2.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps_Text, {
                                size: "17px",
                                align: "center",
                                children: [
                                    "Lakukan pengisian ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " formulir pembukaan rekening ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "secara online"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(InvestStep, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/images/mulai-investasi/step3.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Steps_Text, {
                                size: "17px",
                                align: "center",
                                children: [
                                    "Deposit ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    " dan Beli saham"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Steps = (MulaiInvestasiSteps);

;// CONCATENATED MODULE: ./src/features/mulai-investasi/index.tsx








var MulaiInvestasiFeature = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mulai_investasi_Header, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Steps, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Komisi, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(mulai_investasi_ComparisonGraph, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Benefits, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Features, {})
        ]
    });
};
/* harmony default export */ var mulai_investasi = (MulaiInvestasiFeature);


/***/ }),

/***/ 579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_app__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86123);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);





var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "src",
        "alt"
    ]);
    var source = src || "";
    var isBlob = source.startsWith("blob:");
    var isBase64 = source.startsWith("data:");
    var isUrl = source.startsWith("http") || source.startsWith("//");
    if (source && !isUrl && !isBlob && !isBase64) {
        var separator = source.startsWith("/") ? "" : "/";
        source = "".concat(constants_app__WEBPACK_IMPORTED_MODULE_1__/* .assetPrefix */ .Vc).concat(separator).concat(source);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        src: source,
        alt: alt
    }, rest));
};
Image.defaultProps = {
    alt: ""
};
Image.propTypes = {
    src: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string.isRequired),
    alt: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().string)
};
/* harmony default export */ __webpack_exports__["Z"] = (Image);


/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 7297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}


/***/ })

}]);